import { LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/Button';

export function SignOutButton({ withIcon = false }: { withIcon?: boolean }) {
  const { signOut } = useAuth();

  return (
    <Button
      type="button"
      size="sm"
      variant="secondary"
      className="h-[34px] shrink-0 rounded-lg"
      data-pdf-ignore
      data-html2canvas-ignore="true"
      onClick={() => void signOut()}
    >
      {withIcon ? <LogOut className="h-3.5 w-3.5" aria-hidden /> : null}
      Sign out
    </Button>
  );
}

